//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('ecommerceIntegrationsStart', {
    bindings: {
      continueCallback: '&',
    },
    template: require('@legacy-components/ecommerce-integrations/ecommerce-integrations-start.html'),
  });
})();
